import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { authClient } from '@/lib/auth-client';

interface OAuthButtonProps {
  provider: string;
  label: string;
  icon: React.ReactNode;
  callbackURL?: string;
}

export function OAuthButton({ provider, label, icon, callbackURL }: OAuthButtonProps) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await authClient.signIn.social({
        provider,
        callbackURL: callbackURL || window.location.origin + "/dashboard",
      });
    } catch (error) {
      console.error(`OAuth error with ${provider}:`, error);
      setLoading(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      disabled={loading}
      className="w-full h-11 rounded-full text-base font-medium bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 hover:text-gray-900"
    >
      <span className="mr-2 flex items-center">{icon}</span>
      {loading ? 'Connecting...' : label}
    </Button>
  );
}
